import Table from 'antd/lib/table';
import './Table.scss';

const antDTable = ({ ...rest }) => (
  <div className="table-wrapper">
    <Table {...rest} />
  </div>
);

export default antDTable;